import React from 'react';
import Icon from '../../../components/AppIcon';

const RegistrationBenefits = ({ userType }) => {
  const benefitsByType = {
    job_seeker: {
      title: 'Accelerate Your Career',
      subtitle: 'Join thousands of professionals finding their dream jobs',
      stats: [
        { value: '50K+', label: 'Active Jobs' },
        { value: '95%', label: 'Match Accuracy' },
        { value: '2.5x', label: 'Faster Hiring' }
      ],
      features: [
        {
          icon: 'Brain',
          title: 'AI-Powered Matching',
          description: 'Our AI analyzes your skills and preferences to find perfect job matches'
        },
        {
          icon: 'FileText',
          title: 'Resume Enhancement',
          description: 'Get AI-powered suggestions to optimize your resume for better visibility'
        },
        {
          icon: 'TrendingUp',
          title: 'Career Insights',
          description: 'Receive personalized career advice and market trend analysis'
        },
        {
          icon: 'Bell',
          title: 'Smart Alerts',
          description: 'Get notified instantly when jobs matching your criteria are posted'
        }
      ]
    },
    hiring_manager: {
      title: 'Streamline Your Hiring',
      subtitle: 'Powerful tools to find and hire the best talent faster',
      stats: [
        { value: '1M+', label: 'Candidates' },
        { value: '70%', label: 'Time Saved' },
        { value: '4.8/5', label: 'User Rating' }
      ],
      features: [
        {
          icon: 'Users',
          title: 'Smart Candidate Screening',
          description: 'AI-powered screening to identify the most qualified candidates'
        },
        {
          icon: 'BarChart3',
          title: 'Advanced Analytics',
          description: 'Track hiring metrics and optimize your recruitment process'
        },
        {
          icon: 'MessageSquare',
          title: 'AI Interview Assistant',
          description: 'Get AI-generated interview questions and candidate insights'
        },
        {
          icon: 'Zap',
          title: 'Automated Workflows',
          description: 'Streamline repetitive tasks with intelligent automation'
        }
      ]
    },
    company_admin: {
      title: 'Scale Your Organization',
      subtitle: 'Enterprise-grade recruitment solutions for growing companies',
      stats: [
        { value: '500+', label: 'Companies' },
        { value: '85%', label: 'Faster Onboarding' },
        { value: '24/7', label: 'Support' }
      ],
      features: [
        {
          icon: 'Building2',
          title: 'Company Profile Builder',
          description: 'Create compelling company profiles with AI-enhanced content'
        },
        {
          icon: 'Shield',
          title: 'Team Management',
          description: 'Manage hiring teams, permissions, and collaboration tools'
        },
        {
          icon: 'PieChart',
          title: 'Executive Dashboard',
          description: 'Get high-level insights into your organization\'s hiring performance'
        },
        {
          icon: 'Globe',
          title: 'Multi-location Support',
          description: 'Manage hiring across multiple offices and regions seamlessly'
        }
      ]
    }
  };

  const currentBenefits = benefitsByType?.[userType] || benefitsByType?.job_seeker;

  return (
    <div className="bg-gradient-to-br from-primary/5 to-secondary/5 p-8 rounded-2xl">
      <div className="space-y-8">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-foreground mb-2">
            {currentBenefits?.title}
          </h2>
          <p className="text-muted-foreground">
            {currentBenefits?.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-3 gap-4">
          {currentBenefits?.stats?.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-2xl font-bold text-primary mb-1">
                {stat?.value}
              </div>
              <div className="text-xs text-muted-foreground">
                {stat?.label}
              </div>
            </div>
          ))}
        </div>

        <div className="space-y-4">
          {currentBenefits?.features?.map((feature, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="flex items-center justify-center w-8 h-8 bg-primary/10 rounded-lg flex-shrink-0">
                <Icon name={feature?.icon} size={16} className="text-primary" />
              </div>
              <div>
                <h4 className="font-medium text-foreground text-sm mb-1">
                  {feature?.title}
                </h4>
                <p className="text-xs text-muted-foreground leading-relaxed">
                  {feature?.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="pt-4 border-t border-border/50">
          <div className="flex items-center justify-center space-x-2 text-xs text-muted-foreground">
            <Icon name="Shield" size={14} />
            <span>Enterprise-grade security</span>
            <span>•</span>
            <Icon name="Clock" size={14} />
            <span>24/7 support</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationBenefits;